<n-slide-window
    [visible]="windowVisible"
    [width]="SWITCH.IS_SIMPLE_MODE ? '6.08rem' : '7rem'"
    (onHide)="close()">
    <!-- 标题 -->
    <n-header>
        <h1 nTextTips>{{i18n.createGroupTitle}}</h1>
        <n-help-link key="authenticationwindowusergroupCreate" *ngIf="!SWITCH.IS_SIMPLE_MODE"></n-help-link>
        <n-help-link key="simplifywindowsgroupCreate" *ngIf="SWITCH.IS_SIMPLE_MODE"></n-help-link>
    </n-header>
    <!-- 表单区域 -->
    <form
        [errorMessage]="errorMessage"
        [formGroup]="vm"
        [simpleMode]="SWITCH.IS_SIMPLE_MODE"
        [ngClass]="{ 'form-width-simple': SWITCH.IS_SIMPLE_MODE, 'common-form': !SWITCH.IS_SIMPLE_MODE }">
        <!-- 所属租户 -->
        <n-form-item
            [label]="i18n.vStoreLab" *ngIf="!SWITCH.IS_SIMPLE_MODE"
            [required]="!vstore || !vstore.value">
            <n-select *ngIf="!vstore || !vstore.value"
                #vstoreSelect
                id="create-windows-local-access-group-vstore"
                formControlName="vstoreId"
                [rest]="vstoreRest"
                [filter]="true"
                [labelField]="'NAME'"
                [valueField]="'ID'">
            </n-select>
            <div class="n-form-item-text" *ngIf="vstore && vstore.value">{{vstore.label}}</div>
        </n-form-item>
        <!-- 组名 -->
        <n-form-item
            [label]="i18n.name"
            [required]="true">
            <input
                nInput
                type="text"
                id="create_windows_local_access_group_name"
                formControlName="NAME"
                [placeholder]="errorMessage.NAME.rangeByteLength">
        </n-form-item>
        <!-- 描述 -->
        <n-form-item [label]="i18n.description">
            <textarea
                nTextarea
                id="create_windows_local_access_group_description"
                formControlName="DESCRIPTION"
                [placeholder]="errorMessage.DESCRIPTION.rangeByteLength">
            </textarea>
        </n-form-item>
        <!-- 特权 -->
        <n-form-item
            [labelHide]="true">
            <div class="title-md mt-32">{{i18n.privilege}}</div>
        </n-form-item>
    </form>
    <app-windows-local-access-group-permit-table
        [initData]="str.allPermit"
        [(selectData)]="permitList">
    </app-windows-local-access-group-permit-table>
    <!-- 按钮区域 -->
    <n-footer>
        <button
            nButton
            id="create_windows_local_access_group_ok_btn"
            theme="primary"
            [label]="i18n.ok"
            (click)="onOk()">
        </button>
        <button
            nButton
            id="create_windows_local_access_group_cancel_btn"
            [label]="i18n.cancel"
            (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
